module.exports = __webpack_public_path__ + "img/img57.50d7ab9c.svg";